module.exports = __webpack_public_path__ + "static/media/tick.211308b8.mp3";